import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=43d639b0&scoped=true&"
import script from "./Snackbar.vue?vue&type=script&lang=ts&"
export * from "./Snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=43d639b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d639b0",
  null
  
)

export default component.exports